import { createReducer, on } from '@ngrx/store';
import { ActionStateCreator, IActionState } from '../../../utils';
import {
  LoadDowntimeMessage,
  LoadDowntimeMessageFail,
  LoadDowntimeMessageSuccess,
} from './downtime.actions';

export interface IDownTimeState {
  downtimeMessage: string;
  downtimeMessageActionState: IActionState;
}

export const initialState: IDownTimeState = {
  downtimeMessage: undefined,
  downtimeMessageActionState: ActionStateCreator.create(),
};

export const downtimeReducer = createReducer(
  initialState,

  on(LoadDowntimeMessage, state => {
    return {
      ...state,
      downtimeMessageActionState: ActionStateCreator.onStart(),
    };
  }),

  on(LoadDowntimeMessageSuccess, (state, { downtimeMessage }) => {
    return {
      ...state,
      downtimeMessage,
      downtimeMessageActionState: ActionStateCreator.onSuccess(),
    };
  }),

  on(LoadDowntimeMessageFail, (state, { error }) => {
    return {
      ...state,
      downtimeMessageActionState: ActionStateCreator.onError(error),
    };
  })
);
